import React, { useEffect, useState } from "react";
import './Dashboard.css';
import Popup from "reactjs-popup";
import Sidebar from "./Sidebar/Sidebar";
import { useAuth } from "../../Context/AuthContext";
import Logoutpopup from "../../../Login/Logoutpopup";


interface LoginProps {
    onLogOut: (user: any) => void; // Define the type of onLogin function
}

const Dashboard: React.FC = () => {

    const [showlogoutPopup, setlogoutShowPopup] = useState(false);
    const { logout } = useAuth();
 
    useEffect(() => {
        let timeout: NodeJS.Timeout;

        const resetTimeout = () => {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                setlogoutShowPopup(true);
            }, 120000);
        };

        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
        const resetTimeoutHandler = () => resetTimeout();

        events.forEach(event => {
            document.addEventListener(event, resetTimeoutHandler);
        });


        resetTimeout();


        return () => {
            events.forEach(event => {
                document.removeEventListener(event, resetTimeoutHandler);
            });
            clearTimeout(timeout);
        };
    }, []);

    return (
        <>
            <Sidebar onLogOut={logout} />
            <Popup contentStyle={{ height: 245, width: 350, padding: 0 }} open={showlogoutPopup} onClose={() => setlogoutShowPopup(false)} >
                <Logoutpopup openClose={() => setlogoutShowPopup(false)} hadleLogout={logout} />
            </Popup>
        </>
    );
}

export default Dashboard;